import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const updateSubGroupCamundaReq = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.updateSubGroup_camunda,
    method: 'POST',
    body: data,
    cache: false,
    headers: getHeaders(),
  }
  return executeRequest(request)
    .then((data) => {
      return data
    })
    .catch((err) => {
      throw err
    })
}

export { updateSubGroupCamundaReq }
